import React from 'react';
import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import TimetableIcon from 'mdi-react/TimetableIcon';
import withReactContent from "sweetalert2-react-content";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import renderDateTimePickerField from '@/shared/components/form/date-pickers/DateTimePicker';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel, FormGroupIcon } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const CalibrationsList = (props) => {
    const submitNewCalibration = (calibration) => {
        AdminInterface.instance.createCalibration(calibration).then(() => {
            withReactContent(Swal).fire({
                title: "Success",
                html: "New calibration is created!",
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        });
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New Calibration</CardTitle>
                </CardTitleWrap>
                <Form onSubmit={submitNewCalibration}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Description</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="description" component="input" type="text" placeholder="Description" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Start Datetime</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="calibration_date" component={renderDateTimePickerField} placeholder="Calibration Datetime" validate={required} />
                                    <FormGroupIcon><TimetableIcon/></FormGroupIcon>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>S3 URI</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="s3_uri" component="input" type="text" placeholder="s3://" />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={form.reset}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default CalibrationsList;